export default {"src":"/_next/static/media/instagram-icon.53135099.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};